import { FC, useCallback, useEffect } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { IAdminOrganizationFormValues } from '@interfaces/adminOrganizations';
import { handleAdminCreateNewOrganization } from '@store/features/adminOrganizations/actions';
import { removeAdminOrganizationDetails } from '@store/features/adminOrganizations/slice';
import useDispatch from '@store/hooks/useDispatch';
import { EventType, useEventBus } from '@utils/eventBus';
import handleToast from '@utils/handleToast';

import OrganizationDetailsForm from '../OrganizationDetailsForm/OrganizationDetailsForm';

import { convertFormValuesToCreateNewPayload, validateForm } from './utils';

const NewOrganization: FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const eventBus = useEventBus('adminCreateNewOrganization');

  const handleSubmit = useCallback(
    (values: IAdminOrganizationFormValues) => {
      const payload = convertFormValuesToCreateNewPayload(values);
      return dispatch(handleAdminCreateNewOrganization(payload));
    },
    [dispatch],
  );

  const handleCancel = useCallback(() => {
    dispatch(removeAdminOrganizationDetails());
  }, [dispatch]);

  useEffect(() => {
    eventBus.on(EventType.ADMIN_CREATE_NEW_ORGANIZATION_SUCCESS, () =>
      handleToast('success', t('admin.createNewOrganizationSuccess')),
    );

    return () => eventBus.off(EventType.ADMIN_CREATE_NEW_ORGANIZATION_SUCCESS);
  }, [t, eventBus]);

  return (
    <Form
      // @ts-ignore because of custom props
      component={OrganizationDetailsForm}
      validate={validateForm}
      onSubmit={handleSubmit}
      onCancel={handleCancel}
      isNew
    />
  );
};

export default NewOrganization;
